import type { Thunk, Action } from 'easy-peasy';
import { action, thunk } from 'easy-peasy';
import type { Injections } from '../../services/injections';
import type { ApplicationErrorOptions } from '../../../types';
import type { Packaging, FetchAssetParams, PackagingSet } from '../types';
import parseStatusCode from '../../errors/parseStatusCode';

export interface PackagingModel {
  fetchPackagings: Thunk<PackagingModel, FetchAssetParams, Injections, Promise<Packaging[]>>;
  fetchPackagingSets: Thunk<PackagingModel, FetchAssetParams, Injections, Promise<PackagingSet[]>>;
  packagingActionStart: Action<PackagingModel, void>;
  lastAction?: number;
  packagings: Record<string, Packaging>;
  packagingSets: Record<string, PackagingSet>;
  packagingFailure: Action<PackagingModel, ApplicationErrorOptions>;
  setPackagings: Action<PackagingModel, Packaging[]>;
  setPackagingSets: Action<PackagingModel, PackagingSet[]>;
}

export const packagingModel: PackagingModel = {
  packagings: {},
  packagingSets: {},
  packagingFailure: action((state, payload) => {
    console.error(payload);
  }),
  setPackagings: action((state, payload) => {
    for (const val of payload) {
      state.packagings[val.packagingId] = val;
    }
  }),
  setPackagingSets: action((state, payload) => {
    for (const val of payload) {
      state.packagingSets[val.packagingSetId] = val;
    }
  }),
  packagingActionStart: action((state, payload) => {
    state.lastAction = Date.now();
  }),
  fetchPackagings: thunk(async (actions, payload, { injections }) => {
    try {
      actions.packagingActionStart();
      const res = await injections.assetService.fetchPackagings(payload);
      actions.setPackagings(res);
      return res;
    } catch (error) {
      actions.packagingFailure({
        error,
        httpCode: parseStatusCode(error),
        message: 'An error occured fetching packaging',
        asNotification: true,
      });
    }
  }),
  fetchPackagingSets: thunk(async (actions, payload, { injections }) => {
    try {
      actions.packagingActionStart();
      const res = await injections.assetService.fetchPackagingSets(payload);
      actions.setPackagingSets(res);
      return res;
    } catch (error) {
      actions.packagingFailure({
        error,
        httpCode: parseStatusCode(error),
        message: 'An error occured fetching packaging',
        asNotification: true,
      });
    }
  }),
};
